import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import Translation from '../../../../.././/common/translation/translation.component';
import { EQUIPMENT_TYPE, TRANSLATIONS as translation, CIRCUIT_TYPES as CircuitTypes } from '../../../../../../utils/constant.utils';
import { ORFButton as Button } from '../../../../../common/forms/order-request-form.component';
import { wirelessPortInActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer";
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { InputFieldFloatingLabel } from "../../../../../common/custom-form/select-filter.component";
import { MAX_LENGTH } from "../../../../../../constants/external-constants";
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { Loading } from '../../../../../common/loading/index';
import { withRouter } from 'react-router-dom';

class PortInSubscriptionFormA extends Component {
    constructor(props) {
        super(props);
        this.state={
            mobileAlreadyExist: false,
            serviceTypeExist: false,
            isDevice: false
        }
    }

    componentDidMount() {
        const orderId = this.props.match.params.orderId;
        this.props.loadPortInLocationForm(orderId);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    render() {

        const {
            // component props
            onClickCancel
            , prevAction
            , nextAction
            // form
            , wirelessPortInSubscriptionFormA
            , forms
            // reducer action
            , onVendorSelect
            , onPlanSelect
            , onServiceTypeSelect
            , onCircuitTypeSelect
            , loadingSubscriptionForm
        } = this.props;

        const { planOptions
            , vendorDetails
            , circuitTypeOptions
            , mobileServiceTypeOptions
            , vendorOptions
            , plansDatatable
            , mobileError
        } = this.props.wirelessPortInRequest;

        const planCost = this.props.wirelessPortInRequest.plansDatatable.length > 0 && wirelessPortInSubscriptionFormA.mobileServiceModel.length > 0 ? this.props.wirelessPortInRequest.plansDatatable[0].dataItem[0].TotalComponentCost : 0;

        const totalOrderCost = wirelessPortInSubscriptionFormA.planId
            ? (wirelessPortInSubscriptionFormA.mobileServiceModel.length > 0 && this.props.wirelessPortInRequest.plansDatatable.length > 0
                ? wirelessPortInSubscriptionFormA.mobileServiceModel[0].DiscountedOrderCost + planCost
                : 0)
            : 0;

        const totalOrderCostFormatted = Number(totalOrderCost).toFixed(2);

        const sortedPlanComponentList = this.props.wirelessPortInRequest.plansDatatable.map(item => {
            return {
                ...item,
                dataItem: item.dataItem.slice().sort((a, b) => (a.ComponentCost - b.ComponentCost))
            }
        });

        let disableSubmit = (!wirelessPortInSubscriptionFormA.personalMobile || !forms.wirelessPortInSubscriptionFormA.personalMobile.valid)
            || !wirelessPortInSubscriptionFormA.currentVendor
            || !wirelessPortInSubscriptionFormA.vendorDetailId
            || !wirelessPortInSubscriptionFormA.planId
            || !wirelessPortInSubscriptionFormA.circuitTypeId
            || !wirelessPortInSubscriptionFormA.equipmentInventoryId;
        
        const orderId = this.props.match.params.orderId;

        return loadingSubscriptionForm ?
            <Loading /> :
            (
            <div className="portin-subscription-container">
                <Row>
                    <Col className={`${forms.wirelessPortInSubscriptionFormA.personalMobile.valid ? "margin-bottom-20" : "mb-1"}`} xs={12} md={12} lg={12}>
                        <InputFieldFloatingLabel
                            className="form-control required"
                            type="text"
                            label={`${this.toLocaleLanguage('personal_mobile_number')}`}
                            value={wirelessPortInSubscriptionFormA.personalMobile}
                            onBlurAction={(model, value) => this.props.validateMobileNumber(model, value, this.props.match.params.orderId)}
                            fieldProp='wirelessPortInSubscriptionFormA.personalMobile'
                            placeholder={"Enter text here..."}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                        <InputFieldFloatingLabel
                            className="form-control required"
                            type="text"
                            label={`${this.toLocaleLanguage('current_vendor')}`}
                            value={wirelessPortInSubscriptionFormA.currentVendor}
                            fieldProp='wirelessPortInSubscriptionFormA.currentVendor'
                            placeholder={"Enter text here..."}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                        <InputFieldFloatingLabel
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('account_number')}`}
                            value={wirelessPortInSubscriptionFormA.accountNumber}
                            fieldProp='wirelessPortInSubscriptionFormA.accountNumber'
                            placeholder={"Enter text here..."}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row>
                        <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                        <InputFieldFloatingLabel
                            className="form-control"
                            type="text"
                            label={this.toLocaleLanguage('porting_pin_code')}
                            value={wirelessPortInSubscriptionFormA.portPinCode}
                            fieldProp='wirelessPortInSubscriptionFormA.portPinCode'
                            placeholder={"Enter text here..."}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                        <InputFieldFloatingLabel
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('current_billing_address')}`}
                            value={wirelessPortInSubscriptionFormA.currentBillingAddress}
                            fieldProp='wirelessPortInSubscriptionFormA.currentBillingAddress'
                            placeholder={"Enter text here..."}
                            maxLength={MAX_LENGTH.limit_500}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('vendor')}`}
                            options={vendorOptions.filter(item => item.Value.includes('Preferred'))}
                            placeholder="Select..."
                            fieldProp='wirelessPortInSubscriptionFormA.vendorDetailId'
                            selected={wirelessPortInSubscriptionFormA.vendorDetailId}
                            onChange={(val) => onVendorSelect(val)}
                            requiredField
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="margin-bottom-20" xs={12} md={12} lg={12}>
                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('circuit_type')}`}
                            options={circuitTypeOptions}
                            placeholder="Select..."
                            fieldProp='wirelessPortInSubscriptionFormA.circuitTypeId'
                            selected={wirelessPortInSubscriptionFormA.circuitTypeId}
                            onChange={(val) => onCircuitTypeSelect(val)}
                            requiredField
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className={forms.wirelessPortInSubscriptionFormA.equipmentInventoryId.valid ? "margin-bottom-20" : "mb-1" } xs={12} md={12} lg={12}>
                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('mobile_service_type')}`}
                            options={mobileServiceTypeOptions}
                            placeholder="Select..."
                            fieldProp='wirelessPortInSubscriptionFormA.equipmentInventoryId'
                            selected={wirelessPortInSubscriptionFormA.equipmentInventoryId}
                            onChange={(val) => onServiceTypeSelect("wirelessPortInSubscriptionFormA.equipmentInventoryId", val, orderId)}
                            requiredField
                            optionLabelKey={{
                                Key: 'EquipmentInventoryId',
                                Value: 'EquipmentModel'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                        />
                    </Col>
                </Row>
                {
                    wirelessPortInSubscriptionFormA.circuitTypeId == CircuitTypes.mobile_or_cellphone && wirelessPortInSubscriptionFormA.equipmentInventoryId != undefined && wirelessPortInSubscriptionFormA.equipmentInventoryId != 0 &&
                    <ControlCheckBox
                        classWrapper="custom-checkbox-wrapper"
                        label={`${this.toLocaleLanguage('include_phone_accessory')}`}
                        model="wirelessPortInSubscriptionFormA.phoneCaseAccessory"
                        checked={wirelessPortInSubscriptionFormA.phoneCaseAccessory}
                    />
                }
                <Row>
                    <Col className="required margin-bottom-20" xs={12} md={12} lg={12}>
                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('plan')}`}
                            options={planOptions}
                            placeholder="Select..."
                            fieldProp='wirelessPortInSubscriptionFormA.planId'
                            selected={wirelessPortInSubscriptionFormA.planId}
                            onChange={(val) => onPlanSelect("wirelessPortInSubscriptionFormA.planId", val)}
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_100}                         
                        />
                    </Col>
                </Row>

                    {wirelessPortInSubscriptionFormA.planId ?
                        <TableWithButton
                            classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                            datatable={sortedPlanComponentList}
                            haveExternalDeleteBtn={false}
                            haveCheckBox={true}

                        /> : null}

                <div className="price-plan-total-cost-container">
                    <div className="price-plan-header">
                        <span><Translation translationKey="total_order_cost" /></span>
                    </div>
                    <div className="price-plan-total">
                        <span>{vendorDetails.Currency}</span>
                        <span>{totalOrderCostFormatted}</span>
                    </div>
                </div>

                <div className="request-button-continer">
                    <div className="bottom-left">
                        <Button
                            label={this.toLocaleLanguage('modal_close_cancel_button')}
                            variant={"light"}
                            action={onClickCancel}
                            type="button"
                        />
                    </div>
                    <div className="bottom-right">
                        <div>
                            <Button
                                label={this.toLocaleLanguage('back')}
                                variant={"outline-secondary"}
                                type={"button"}
                                action={prevAction}
                                className="btn-custom-violet-hover-outline"
                            />
                        </div>
                        <div>
                            <Button
                                label={this.toLocaleLanguage('next_button')}
                                variant={"primary"}
                                type={"button"}
                                action={nextAction}
                                disabled={disableSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};


export default withRouter(
    connect(
        state => {
            const { wirelessPortInRequest, translation } = state;
            const { wirelessPortInSubscriptionFormA, forms } = state.form;
            return {
                wirelessPortInRequest
                , wirelessPortInSubscriptionFormA
                , forms
                , ...translation,
            };
        }
        , dispatch =>
            bindActionCreators(
                Object.assign({}, wirelessPortInActions),
                dispatch
            )
    )(PortInSubscriptionFormA)
);